// extracted by mini-css-extract-plugin
export default {"link":"Link_link__wk9ef","link--prev":"Link_link--prev__XQTL-","link--nav":"Link_link--nav__LQbBR","link--primary":"Link_link--primary__whSqD"};